import { useNavigate } from 'react-router';

import { type PlatformChannel } from '../../utils';
import { useProStudioCtxSelector } from '../../xstate/app.xstate';

/**
 * Navigates to a channel's settings page from a project-settings table.
 * The channel route is `/:projectId/:botId/channels/:channelId`, where `:botId`
 * is the solution id — resolved here from the channel's start-chat bot id via
 * the project's solutions (`solution.botSolutionId`). A Contact Center (vaapi)
 * channel has no settings page in Pro Studio, so it opens the Channels list.
 */
export const useGoToChannel = () => {
  const navigate = useNavigate();
  const { projectId, solutions } = useProStudioCtxSelector((ctx) => ({
    projectId: ctx.project?.id,
    solutions: ctx.solutions,
  }));

  return (channel: PlatformChannel) => {
    const solutionId = solutions?.find(
      (solution) => solution.botSolutionId === channel.botId
    )?.id;

    if (!projectId || !solutionId || !channel.channelId) return;

    const base = `/${projectId}/${solutionId}`;
    if (channel.type === 'vaapi') {
      navigate(`${base}/channels`);
    } else if (channel.type === 'twilio_voice') {
      navigate(`${base}/voice-channel/${channel.channelId}`);
    } else {
      navigate(`${base}/channels/${channel.channelId}`);
    }
  };
};
